module.exports = __webpack_public_path__ + "img/wei_sao.bd261441.png";